import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import MetaControl from 'Components/UI/Meta/MetaControl';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import { Collapse } from '@mui/material';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '700px',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  question: {
    paddingBottom: theme.spacing(7),
  },
  questionTitle: {
    textAlign: 'start',
    paddingBottom: theme.spacing(2),
  },
});

const hasInvested = (value) => {
  return value !== 'riskToleranceQuestionInvestingExperience-4';
};

const shouldRenderQuestion = (questionType, hasInvestedBefore) => {
  if (questionType !== 'riskToleranceQuestionInvestingHistory') {
    return true;
  }

  return hasInvestedBefore;
};

function Layout({
  classes,
}) {
  const {
    resource,
    metaOverrideSet,
    handleChange,
  } = useMetaLayoutContext();
  const questions = resource?.attr('questions').resources().list();
  const [hasInvestedBefore, setHasInvestedBefore] = useState(false);

  const handleOnChange = (v, i) => {
    resource?.attr('questions').resources().list()[i].attr('answer', v);
    handleChange('questions', resource?.attr('questions'));
    if (v.includes('riskToleranceQuestionInvestingExperience')) {
      const hasInvestedValue = hasInvested(v);
      const investingHistoryQuestion = questions.find((question) => question.attr('type') === 'riskToleranceQuestionInvestingHistory');
      // if the user has not invested before, they should not answer the investing history question
      // so we will clear the answer to that question
      if (!hasInvestedValue && investingHistoryQuestion) {
        investingHistoryQuestion.attr('answer', '');
      }
      setHasInvestedBefore(hasInvestedValue);
    }
  };

  return (
    <div className={classes.root}>
      <Header title={resource?.attr('title')} />
      {questions.map((question, i) => {
        const shouldRender = shouldRenderQuestion(question.attr('type'), hasInvestedBefore);

        return (
          <Collapse in={shouldRender}>
            <div className={classes.question} key={question.id()}>
              <Text className={classes.questionTitle} text={question.attr('question')} variant="h4" weight="medium" />
              <MetaControl
                resource={question}
                attrName={'answer'}
                metaOverrideSet={metaOverrideSet}
                onChange={(v) => {
                  handleOnChange(v, i);
                }}
                test={question.attr('type')}
              />
            </div>
          </Collapse>
        );
      })}
    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
